import * as actionTypes from '../consts/actionTypes';

const initialState = {
    sedes: [],
    msgError: ''
};

export default function sedesReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SUCCESS_GET_ALL_HEADQUATERS]: responseToReturn(),
        [actionTypes.FAILURE_GET_ALL_HEADQUATERS]: responseToReturn()
    };
    function responseToReturn() {
        let res = { ...state };
        if (action.response) {
            res = { ...state, sedes: action.response.data.sedes, msgError: action.message };
        }
        if (action.message) {
            res = { ...state, msgError: action.message };
        }
        return res;
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}